import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

/**
 * Default loading spinner component for the isLoading directive.
 * Displays an animated circular spinner with proper accessibility attributes.
 */
@Component({
  selector: 'app-is-loading-spinner',
  template: `
    <div class="is-loading-spinner" role="status" aria-live="polite" aria-atomic="true">
      <svg class="spinner" viewBox="0 0 50 50" aria-hidden="true">
        <circle 
          class="spinner-path" 
          cx="25" 
          cy="25" 
          r="20" 
          fill="none" 
          stroke-width="5"
        ></circle>
      </svg>
      <span class="visually-hidden">Loading…</span>
      <p *ngIf="message" class="loading-message">{{ message }}</p>
    </div>
  `,
  styles: [`
    .is-loading-spinner {
      display: block;
      text-align: center;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      min-height: 3rem;
    }

    .spinner {
      width: 2.5rem;
      height: 2.5rem;
      animation: spinner-rotate 2s linear infinite;
    }

    .spinner-path {
      stroke: currentColor;
      stroke-linecap: round;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      animation: spinner-dash 1.5s ease-in-out infinite;
    }

    .visually-hidden {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    @keyframes spinner-rotate {
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes spinner-dash {
      0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
      }
    }

    .loading-message {
      margin-top: 0.75rem;
      margin-bottom: 0;
      font-size: 0.875rem;
      color: currentColor;
      opacity: 0.8;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsLoadingSpinnerComponent {
  /**
   * Optional message to display below the spinner
   */
  @Input() message?: string;
}